/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * 
 * @export
 * @interface GetMenuOrderChatResponse
 */
export interface GetMenuOrderChatResponse {
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof GetMenuOrderChatResponse
     */
    chatMessages: Array<ChatMessage>;
}

/**
 * Check if a given object implements the GetMenuOrderChatResponse interface.
 */
export function instanceOfGetMenuOrderChatResponse(value: object): value is GetMenuOrderChatResponse {
    if (!('chatMessages' in value) || value['chatMessages'] === undefined) return false;
    return true;
}

export function GetMenuOrderChatResponseFromJSON(json: any): GetMenuOrderChatResponse {
    return GetMenuOrderChatResponseFromJSONTyped(json, false);
}

export function GetMenuOrderChatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrderChatResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'chatMessages': ((json['chatMessages'] as Array<any>).map(ChatMessageFromJSON)),
    };
}

export function GetMenuOrderChatResponseToJSON(json: any): GetMenuOrderChatResponse {
    return GetMenuOrderChatResponseToJSONTyped(json, false);
}

export function GetMenuOrderChatResponseToJSONTyped(value?: GetMenuOrderChatResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chatMessages': ((value['chatMessages'] as Array<any>).map(ChatMessageToJSON)),
    };
}

